import styled from 'styled-components'
import { themeGet } from '@style'
import { layout } from 'styled-system'

const Banner = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.deepSafron')};
  color: ${themeGet('colors.light')};
  padding-top: ${themeGet('space.1')};
  padding-bottom: ${themeGet('space.1')};
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${themeGet('fontSizes.0')};

  @media screen and (min-width:576px) {
    height: 32px;
  }
  ${layout}
`

export default Banner
